/**
 * This filter formats a raw NWEA RIT score range to something more user-friendly.
 */
angular.module('edxComponents')
  .filter('edxNweaScoreRange', [function() {
      return function(score) {
          // Raw score range is delimited by underscores. We want to show dashes instead.
          return score ? score.replace('_', ' - ') : '';
      };
  }]);
